import { Injectable } from '@angular/core';
import { GET_LOCATION_SECTOR_MAINTENANCES_QUERY } from '@api/location-sectors/location-sectors.query';
import { Maintenance, PagedResult } from '@core/interfaces';
import { LocationSector } from '@core/interfaces/locations-sectors';
import { Apollo } from 'apollo-angular';

interface GetSectorMaintenancesParams {
  id: string;
  take: number;
  after?: string;
}

@Injectable({
  providedIn: 'root'
})
export class TabMaintenancesService {
  constructor(private readonly apollo: Apollo) { }

  public async getSectorMaintenances({ id, take, after }: GetSectorMaintenancesParams): Promise<PagedResult<Maintenance>>  {
    return this.apollo
      .query<LocationSector>({
        query: GET_LOCATION_SECTOR_MAINTENANCES_QUERY,
        variables: { id, take, after }
      })
      .toPromise()
      .then(({ data }) => data['locationSector']['maintenances']);
  }
}
